import config from '../../config';
import APIService from './APIService';

export default class DownloadService extends APIService {
  static downloadFile(archiveId, attachmentList, orgId) {
    let url =
      config.baseUrlForProjectSearch +
      '/v1/archives/' +
      encodeURIComponent(archiveId) +
      '/downloadAttachments?current_org=' +
      orgId;
    let data = {
      attachmentIds: attachmentList
    };
    return this.post(url, data, 'blob');
  }
  /**
   *
   * @param {*} param
   */
  static downloadEmail({ archiveIds, orgId }) {
    let url = config.baseUrlForProjectSearch + '/v1/archives';
    return this.post(url, { archiveIds, currentOrg: orgId }, 'blob');
  }
  /**
   *
   * @param {*} response
   */
  static downloadZipFile(response) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'attachment.zip'); //or any other extension
    document.body.appendChild(link);
    link.click();
  }
  /**
   *
   * @param {*} param
   */
  static downloadAFile({ response, fileName, fileType }) {
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      fileName + (String(fileType).startsWith('.') ? fileType : '.' + fileType)
    ); //or any other extension
    document.body.appendChild(link);
    link.click();
  }
  /**
   *
   * @param {*} response
   */
  static downloadEMLFile(response) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'attachment.eml'); //or any other extension
    document.body.appendChild(link);
    link.click();
  }
}
